// src/components/tasks/GlobalTaskDrawer.jsx
import React from 'react';
import TaskDetailDrawer from './TaskDetailDrawer';
import { useTaskUrlSync } from '../../hooks/useTaskUrlSync';

/**
 * GlobalTaskDrawer - Wrapper component that includes URL sync
 * This component should be rendered inside the Router context
 */
const GlobalTaskDrawer = () => {
  // Initialize URL sync
  useTaskUrlSync();
  
  return <TaskDetailDrawer />;
};

export default GlobalTaskDrawer;